<div class="flex flex-col flex-auto items-center sm:justify-center min-w-0 md:p-8">
    <div class="flex md:w-full md:max-w-6xl sm:rounded-2xl sm:shadow overflow-hidden sm:bg-card">
        <div class="w-full sm:w-auto py-8 px-4 sm:p-12 md:p-16">
            <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
                <!-- Logo -->
                <div class="w-80">
                    <img src="assets/images/logo/logo.svg" alt="Skybox">
                </div>

                <!-- Title -->
                <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">Sign in</div>
                <div>
                    <a
                        class="ml-1 text-primary-500 hover:underline cursor-pointer"
                        (click)="studioTokenLogin()">Use Studio Token
                    </a>
                </div>
<!--                <div class="flex items-baseline mt-0.5 font-medium">-->
<!--                    <div>Don't have an account?</div>-->
<!--                    <a-->
<!--                        class="ml-1 text-primary-500 hover:underline"-->
<!--                        [routerLink]="['/sign-up']">Sign up-->
<!--                    </a>-->
<!--                </div>-->

                <!-- Alert -->
                <fuse-alert
                    class="mt-8 -mb-4"
                    *ngIf="showAlert"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'">
                    {{alert.message}}
                </fuse-alert>
                    <!-- Single sign-on buttons -->
                    <div class="flex items-center mt-8 space-x-4">
                        <button
                            (click)="login(false)"
                            class="flex-auto"
                            type="button"
                            [disabled]="isloginactive"
                            mat-stroked-button>
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:rocket-launch'"></mat-icon>
                            <span *ngIf="!isloginactive || this._authService.oidcConfigId === 'CXone-Fedramp'">
                              CXone
                            </span>
                            <mat-progress-spinner
                                *ngIf="isloginactive && this._authService.oidcConfigId === 'CXone-Standard'"
                                [diameter]="24"
                                [mode]="'indeterminate'"></mat-progress-spinner>
                        </button>
                        <button
                            (click)="login(true)"
                            class="flex-auto"
                            type="button"
                            [disabled]="isloginactive"
                            mat-stroked-button>
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:rocket-launch'"></mat-icon>
                            <span *ngIf="!isloginactive || this._authService.oidcConfigId === 'CXone-Standard'">
                              CXone-Gov
                            </span>
                            <mat-progress-spinner
                                *ngIf="isloginactive && this._authService.oidcConfigId === 'CXone-Fedramp'"
                                [diameter]="24"
                                [mode]="'indeterminate'"></mat-progress-spinner>
                        </button>
                    </div>
                <div style="text-align: center;">
                    <a
                        class="ml-1 text-primary-500 hover:underline cursor-pointer"
                        (click)="logOutSession()">Clear Session
                    </a>
                </div>
            </div>
            <div style="margin-top:40px;">
                <span style="width:50%;float: left;">
                    <a
                        class="ml-1 text-primary-500 hover:underline cursor-pointer"
                        href= "mailto:support@skyboxcommunications.com?subject=AAC Support">Contact Support
                    </a>
                </span>
                <span style="width:50%;float: right;text-align: right;">
                        <a class="ml-1 text-primary-500 hover:underline cursor-pointer"
                           href= "mailto:support@skyboxcommunications.com?subject=AAC Subscription Inquiry&body=Skybox Team,%0A%0AI would like to inquire about setting up a subscription for the Advanced Administrator Console.%0A%0AContact Name:%0ABU #:%0ASubscription duration: (monthly/yearly)%0APhone Number:%0A">Subscription Inquiry
                        </a>
                    </span>
            </div>
        </div>

        <div class="relative hidden md:flex flex-auto items-center justify-center h-full p-16 lg:px-24 overflow-hidden bg-gray-800 dark:border-l">
            <!-- Background - @formatter:off -->
            <!-- Rings -->
            <svg class="absolute inset-0 pointer-events-none"
                 viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
                <g class="text-gray-700 opacity-25" fill="none" stroke="currentColor" stroke-width="100">
                    <circle r="234" cx="196" cy="23"></circle>
                    <circle r="234" cx="790" cy="491"></circle>
                </g>
            </svg>
            <!-- Dots -->
            <svg class="absolute -top-16 -right-16 text-gray-700"
                 viewBox="0 0 220 192" width="220" height="192" fill="none">
                <defs>
                    <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                        <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                    </pattern>
                </defs>
                <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
            </svg>
            <!-- @formatter:on -->
            <!-- Content -->
            <div class="z-10 relative w-full max-w-2xl">
                <div class="text-6xl font-bold leading-none text-gray-100">
                    <div>Advanced Admin Console</div>
                </div>
                <div class="mt-6 text-lg tracking-tight leading-6 text-gray-400">
                    The Skybox Advanced Administrator Console allows CXone admins to quickly make changes to the configuration of the CXone platform.  Start saving hours of your day using the tool that the leading implementation partner uses.
                </div>
                <div class="flex items-center mt-8">
                    <div class="flex flex-0 items-center -space-x-1.5">
                        <img
                            class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                            src="assets/images/avatars/female-18.jpg"
                            alt="female-18">
                        <img
                            class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                            src="assets/images/avatars/female-11.jpg"
                            alt="female-11">
                        <img
                            class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                            src="assets/images/avatars/male-09.jpg"
                            alt="male-09">
                        <img
                            class="flex-0 w-10 h-10 rounded-full ring-4 ring-offset-1 ring-gray-800 ring-offset-gray-800 object-cover"
                            src="assets/images/avatars/male-16.jpg"
                            alt="male-16">
                    </div>
                    <div class="ml-4 font-medium tracking-tight text-gray-400">...over 800 customers implemented on the CXone Platform</div>
                </div>
            </div>
        </div>
    </div>
</div>
